import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[70vh] w-full flex-col items-center justify-center px-4 py-20 text-center">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-compass-3-line text-4xl"></i>
      </span>
      <p className="mt-6 font-brand text-5xl text-primary-500">404</p>
      <h1 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm text-foreground-500">
        你访问的页面不存在或已被移除：<span className="font-mono text-foreground-700">{location.pathname}</span>
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-search-line"></i>
          搜索资讯
        </Link>
      </div>
    </div>
  );
}